import type { SystemStyleObject } from '@chakra-ui/react'
import { Heading } from '@chakra-ui/react'

export const SectionHeading = ({ children, sx, ...rest }: { children: React.ReactNode, sx?: SystemStyleObject }) => {
  return (
    <Heading sx={{ fontSize: 'xl', fontWeight: 'normal', mt: 1, mb: 2, ...sx }} {...rest}>{children}</Heading>
  )
}